import { useEffect } from "react";

const steps = [
  {
    number: "01",
    title: "Combien coûteront les risques climatiques ? ",
    description:
      "Avec notre moteur actuariel, nous connaissons le coût du risque aujourd'hui. En estimant la fréquence et l'intensité des pertes, nous estimons l'évolution par aléa en 2035 et 2050.",
    label: "ANALYSE & MODÉLISATION",
  },
  {
    number: "02",
    title: <>Personnaliser l'analyse,<br />répondre à vos questions</>,
    description:
      "Vous pouvez ajuster vos rendements, vos prix, les surfaces actuelles ou envisagées, pour obtenir des réponses au plus près de vos interrogations.",
    label: "ÉCHANGES",
  },
  {
    number: "03",
    title: "Identifier les meilleures solutions",
    description:
      "A partir des solutions agronomiques, techniques, financières ou assurantielles, comparez l'efficacité de vos stratégies.",
    label: "PLAN D'ACTION",
  },
];

const styles = `
  @import url("https://fonts.googleapis.com/css2?family=Bungee+Shade&display=swap");

  .methode-section {
    padding: 3rem 2rem;
    width: 90%;
    font-family: inherit;
  }

  .methode-header {
    text-align: center;
    margin-bottom: 2.5rem;
  }

  .methode-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0;
    align-items: stretch;
  }

  .step-card {
    display: flex;
    flex-direction: column;
    padding: 0 2rem;
    border-right: 2px solid #92d050;
  }


  .step-card:last-child {
    border-right: none;
  }

  .step-number {
    font-family: "Bungee Shade", cursive;
    font-size: 52px;
    color: #92d050;
    line-height: 1;
    margin-bottom: 14px;
    display: block;
  }

  .step-description {
    flex: 1;
  }

  .step-footer {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    width: fit-content;
  }

  .step-label-line {
    height: 2px;
    background-color: #92d050;
    width: 100%;
  }
  
   @media (orientation: landscape) {
    .methode-section {
      width: 80%;
  }
`;

export default function Methode3Etapes() {
  useEffect(() => {
    const styleTag = document.createElement("style");
    styleTag.textContent = styles;
    document.head.appendChild(styleTag);
    return () => document.head.removeChild(styleTag);
  }, []);

  return (
    <section className="methode-section">
      <div className="methode-header">
        <div className="paragrapheAccueil" style={{ fontWeight: "bold", textAlign: "center", color: "#57802B", marginTop: "0px" }}>
          Avançons en 3 étapes
        </div>
        <p className="paragrapheLanding" style={{ marginTop: "5px" }}>
          Des premiers échanges au plan d'action – une démarche structurée et personnalisée
        </p>
      </div>

      <div className="methode-grid">
        {steps.map((step) => (
          <div key={step.number} className="step-card">
            <span className="step-number">{step.number}</span>
            <h3 className="paragrapheLanding" style={{ fontWeight: "bold", marginTop: "0px" }}>
              {step.title}
            </h3>
            <p className="paragrapheLanding step-description" style={{ marginTop: "0px" }}>
              {step.description}
            </p>
            <div className="step-footer">
              <div className="step-label-line" />
              <span className="paragrapheLanding" style={{ color: "#92d050", fontWeight: "bold" }}>
                {step.label}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
